import { render, staticRenderFns } from "./GameDetailsPopup.vue?vue&type=template&id=56d8f38f&scoped=true"
import script from "./GameDetailsPopup.vue?vue&type=script&lang=js"
export * from "./GameDetailsPopup.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/mkt-cms.css?vue&type=style&index=0&id=56d8f38f&prod&scoped=true&lang=css&external"
import style1 from "./GameDetailsPopup.vue?vue&type=style&index=1&id=56d8f38f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d8f38f",
  null
  
)

export default component.exports